/**
 * フォームの送信ボタン連打による連続送信防止
 * */
const blockContinuitySubmit = () => {
    const target = document.querySelector('[type="submit"]');
    if (!target) return;

    target.addEventListener('click', (e) => {
        this.disabled = true; // ボタンを無効化
        this.closest('form').submit(); // フォームを送信
    });
}

export default blockContinuitySubmit;